import { Trans } from '@lingui/macro'
import { Link } from 'react-router-dom'

import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'

import PageContainer from '@/components/ui/containers/PageContainer'
import AddPatientIcon from '@/components/ui/icons/AddPatient'
import { OfflineStatusIndicator } from '@/shared/offline'
import { useOfflineMode } from '@/providers/OfflineModeProvider'
import { OfflineInitializing } from '@/shared/offline'

import { usePatientsLoader } from '../model/usePatientsLoader'
import { usePatients } from '../model/usePatients'
import { Searchbar } from './Searchbar'
import { OfflinePatients } from './OfflinePatients'

export function OfflinePatientsPage() {
  const { isOfflineDatabaseReady } = useOfflineMode()

  const { patients, loading } = usePatientsLoader(isOfflineDatabaseReady)
  const { patients: paginatedPatients, page, rowsPerPageOptions, setFilter, totalPatients } = usePatients(patients)

  // Show loading state while database is initializing
  if (!isOfflineDatabaseReady) {
    return <OfflineInitializing />
  }

  return (
    <PageContainer>
      <OfflineStatusIndicator />
      <Grid container spacing={2}>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={12}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <Button component={Link} disableElevation startIcon={<AddPatientIcon htmlColor="#FFF" />} to="/offline/patients/create" variant="contained">
                <Trans>New patient</Trans>
              </Button>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Searchbar setFilter={setFilter} />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <OfflinePatients
            loading={loading}
            patients={paginatedPatients}
            page={page}
            rowsPerPageOptions={rowsPerPageOptions}
            setFilter={setFilter}
            totalPatients={totalPatients}
          />
        </Grid>
      </Grid>
    </PageContainer>
  )
}

export default OfflinePatientsPage
